export enum AccessType {
    None = 0,
    Private = 1,
    Shared = 2,
    SharedReadOnly = 3
}

export enum AggregateType {
    None = 0,
    SimpleAggregation = 1,
    VariancePercentFromAggregate = 2,
    VarianceAmountFromAggregate = 3,
    SingleDayAggregateInPast = 4,
    Timestamp = 5,
}

export enum ConfigurationDurationEnum {
    MultipleTimeFrames = 0,
    CurrentSingleTimeFrame = 1,
    PreviousSingleTimeFrame = 2,
    SpecificStartOrStop = 3
}

export enum ConfigurationType {
    Invalid = 0,
    Report = 1,
    Trending = 2,
    FacilityListing = 3,
    GasAnalysis = 4,
    SummaryListing = 5,
    AnalyticsModelData = 6,
    TagCalculation = 7,
    Mapping = 8
}

export enum DataSourceType {
    CurrentData = 1,
    EventLog = 2,
    AlarmStatus = 3
}

export enum DateRangeType {
    Invalid = -1,
    Raw = 0,
    Minute = 1,
    Hour = 2,
    Day = 3,
    Week = 4,
    Month = 5,
    Year = 6
}

export enum DurationTimeframeTypeEnum {
    MultipleTimeFrames = 0,
    CurrentSingleTimeFrame = 1,
    PreviousSingleTimeFrame = 2,
    SpecificStartOrStop = 3
}

export enum OptionalColumnEnum {
    DeviceID = 1,
    DeviceName = 2,
    DeviceDisplayName = 3,
    DeviceIdentifier = 4,
    DeviceLocation = 5,
    TagID = 6,
    ColumnName = 7,
    Sum = 8,
    Date = 9,
    ObjectOrder = 10,
    DeviceTypeName = 11,
    DeviceSubtypeName = 12,
    TagAssociationTypeID = 13,
    ObjectID = 14,
    ObjectTypeID = 15,
    ObjectName = 16,
    TagAssociationTypeName = 17,
    TagName = 18,
    DeviceLatitude = 19,
    DeviceLongitude = 20,
    DeviceAttribute = 21,
    TagAttribute = 22,
    NetFormat = 23,
    ExcelFormat = 24,
    FacilityID = 25,
    //ResourceTypeID = 26,
    UnitDisplayName = 26,
    DeviceExternalID = 27,
    TagExternalID = 28,
    //SetPointEventTypeID = 29,
    UnitMarkupName = 29,
    UnitID = 30,
    DeviceCommAddress = 31,
    DeviceCommStatus = 32,
    TagLKVAlarmStatus = 33,
    TagLKVAlarmColor = 34,
    Memos = 35,
    TATDefaultTrendGallery = 36,
    TATDefaultTrendColor = 37,
    TankLevelTransmitterType = 38,
    TankStyleDescription = 39,
    TankBarrelsPerInch = 40,
    TankHeight = 41,
    TankCapacity = 42,
    TankBatteryName = 43,
    TankDeviceSubtypeName = 44,
    SystemBalanceType = 45,
    SystemBalancePercent = 46,
    TagLKVStaleDataStatus = 47,
    TagLKVStaleDataColor = 48,
    Static = 49,
    DeviceCommIdentifier = 50,
    DeviceCommTypeID = 51,
    UniqueIdentifier = 52,
    GroupID = 53,
    GroupDescription = 54,
    FacilityName = 55,
    Tank_BatteryID = 56,
    Tank_BatteryName = 57,
    Tank_ParentDeviceID = 58,
    Tank_ParentDeviceDisplayName = 59,
    DeviceTypeID = 60,
    DeviceSubtypeID = 61,
    TankDeviceSubtypeID = 62,
    WellID = 63,
    WellName = 64,
    WellAttribute = 65,
    WellLatitude = 66,
    WellApiWui = 68,
    WellLiftTypeID = 69,
    WellLiftTypeName = 70,
    WellResourceTypeID = 71,
    WellResourceTypeName = 72,
    PadID = 73,
    PadName = 74,
    FieldID = 75,
    FieldName = 76,
    BasinID = 77,
    BasinName = 78,
    DeviceGuid = 79,
    TagGuid = 80,
    WellGuid = 81,
    TankGuid = 82,
    GroupGuid = 83,
    TankBatteryGuid = 84,
    DeviceAttributeSchema = 85,
    WellAttributeSchema = 86,
    TankAttributeSchema = 87,
    TagAttributeSchema = 88,
    MemoTimestamp = 89
}

export enum EventColumnEnum {
    ObjectName = 1,
    EventType = 2,
    StartTime = 3,
    EndTime = 4,
    Duration = 5,
    Notes = 6
}

export enum Scope {
    Hidden = 0,
    Internal = 1,
    Custom = 2,
    Customer = 3,
    User = 4
}

export enum SortOrder {
    None = 0,
    Ascending = 1,
    Descending = 2
}

export enum Style {
    Custom = 0,
    Linear = 1,
    Pivot_Object_Timeframe = 2,
    Pivot_Timeframe_Object = 3,
    Pivot_Object_TAT = 4,
    Data_Type_Specific = 5,
    Pivot_Object_Only = 6,
    Pivot_Events = 8
}

export enum TatColumnFormulaType {
    None = 0,
    Expression = 1,
    Rounding = 2,
    DateAdd = 3
}

export enum TimeframeType {
    Raw = 1,
    Hourly = 2,
    Daily = 3,
    Weekly = 4,
    Monthly = 5,
    Yearly = 6,
    LastKnownValue = 7,
    AutoScale = 8,
    LastValueBeforeTimestamp = 9,
    LastValueBeforeOrAtTimestamp = 10,
    FirstValueAfterTimestamp = 11,
    FirstValueAfterOrAtTimestamp = 12,
    Minute = 13
}

export enum ColumnType {
    Optional = 0,
    Tat = 1,
    TatType = 2,
    MetaData = 3,
    Event = 4
}

export enum MetaDataType {
    None = 0,
    Sparkline = 1
}

export enum UsageType {
    Internal = 0,
    Allowed = 1,
    Default = 2,
    Required = 3
}

export enum RepeatUnit {
    Minute = 0,
    Hour = 1,
    Day = 2,
    Week = 3,
    Month = 4,
    Year = 5,
}

export enum ScheduleAction {
    Ignore = 0,
    Include = 1,
    Exclude = 2,
    Delete = 3
}

export enum DurationUnit {
    Hour = 1,
    Day = 2,
    Week = 3,
    Month = 4,
    Year = 5
}
